



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TheHomePageHeader from '@/components/TheHomePageHeader.vue';
import TheHomePageHeroSection from '@/components/TheHomePageHeroSection.vue';
import TheHomePageOurMissionSection from '@/components/TheHomePageOurMissionSection.vue';
import TheHomePageWhyYouNeedSection from '@/components/TheHomePageWhyYouNeedSection.vue';
import TheHomePageWhatImpliesSection from '@/components/TheHomePageWhatImpliesSection.vue';
import TheHomePageDocumentsAndLegislationSection from '@/components/TheHomePageDocumentsAndLegislationSection.vue';
import TheHomePageFAQSection from '@/components/TheHomePageFAQSection.vue';
import TheHomePageContactSection from '@/components/TheHomePageContactSection.vue';
import TheHomePageFooter from '@/components/TheHomePageFooter.vue';
import OverlayMenu from '@/components/OverlayMenu.vue';

@Component({
    components: {
        TheHomePageHeader,
        TheHomePageHeroSection,
        TheHomePageOurMissionSection,
        TheHomePageWhyYouNeedSection,
        TheHomePageWhatImpliesSection,
        TheHomePageDocumentsAndLegislationSection,
        TheHomePageFAQSection,
        TheHomePageContactSection,
        TheHomePageFooter,
        OverlayMenu
    }
})
export default class HomePage extends Vue {
   isOverlayMenuOpen() {
       return this.$store.state.isOverlayMenuOpen;
   }

   printStoreState() {
       return `The value of the store state is: ${this.$store.state.isOverlayMenuOpen}`;
   }
}
